import { useState } from "react";
import { MoonOutlined, SunOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { ThemeModal } from "../../../components/ProfileDropdown";
import { useIsDarkTheme } from "../../../store/hooks";

// Темата на ПИН екрана е тази на ОБЩИЯ акаунт (терминала): бутонът отваря
// същия ThemeModal като профилното меню, а записът минава през същия
// `PUT /configuration/user` — само че с терминалния токен, тоест в реда на
// общия акаунт (hooks/useSharedAccountInfo.ts). Служителят, влязъл с код,
// после вижда СВОЯТА тема (UserConfigurationSync).
export default function KeypadThemeButton({
  onOpenChange,
}: {
  /** Клавиатурата спира да трупа клавиши в кода, докато модалът е отворен. */
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation();
  const isDark = useIsDarkTheme();
  const [open, setOpen] = useState(false);

  const setModalOpen = (next: boolean) => {
    setOpen(next);
    onOpenChange(next);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setModalOpen(true)}
        title={t("common.theme")}
        aria-label={t("common.theme")}
        className="inline-flex h-[calc(var(--u)*36)] w-[calc(var(--u)*36)] shrink-0 items-center justify-center rounded-[calc(var(--u)*10)] border border-shade-3 bg-transparent text-[length:calc(var(--u)*14)] text-pos-body hover:bg-surface/60 transition"
      >
        {isDark ? <MoonOutlined /> : <SunOutlined />}
      </button>
      <ThemeModal open={open} onClose={() => setModalOpen(false)} />
    </>
  );
}
